import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindEditoMariageLandingContent($id: String!)
{
  findEditoMariageLandingContent(id: $id) {
    data {
      pageTitle { iv }

      seoDescription { iv }
      seoKeywords { iv }
      seoThumbnail {
        iv {
          url
        }
      }

      titleBlocTitle { iv }
      titleBlocSubTitle { iv }
      titleBlocFontSizeTitle { iv }
      titleBlocFontSizeSubTitle { iv }
      titleBlocTextColor { iv }
      titleBlocColor { iv }
      titleBlocCtaLink { iv }
      titleBlocCtaText { iv }
      titleBlocFontSizeSubTitle { iv }
      titleBlocFontSizeTitle { iv }
      titleBlocPicture {
        iv {
          url
          fileSize
        }
      }
      titleBlocVerticalPosition { iv }
      titleBlocHorizontalPosition { iv }
      titleBlocJustification { iv }
      
      editoText{ iv }
      editoText2 { iv }
      
      upperTitle : title { iv }
      upperTitleFontSize : fontSizeTitle { iv }
      upperTitleColor: titleTextColor { iv }
      upperText { iv }
      upperPicture {
        iv {
          url
          fileSize
        }
      }
      lowerTitle { iv }
      lowerTitleFontSize { iv }
      lowerTitleColor { iv }
      lowerText { iv }
      lowerPicture {
        iv {
          url
          fileSize
        }
      }
      suppTitle { iv }
      suppTitleFontSize { iv }
      suppTitleColor { iv }
      suppText { iv }
      suppPicture {
        iv {
          url
          fileSize
        }
      }

      videoLink { iv }
      videoText { iv }
      videoPlaceholder {
        iv {
          url
          fileSize
        }
      }

      doubleStaggeredText { iv }
      doubleStaggeredColor { iv }
      doubleStaggeredPicture1 {
        iv {
          url
          fileSize
        }
      }
      doubleStaggeredPicture2 {
        iv {
          url
          fileSize
        }
      }

      zoomedRibbonTitle { iv }
      zoomedRibbonTextColor { iv }
      zoomedRibbonColor { iv }
      zoomedRibbonElementByLine { iv }
      zoomedRibbonItems {
        iv {
          picture {
            url
            fileSize
          }
          title
        }
      }

      zoomedRibbon2Title { iv }
      zoomedRibbon2TextColor { iv }
      zoomedRibbon2Color { iv }
      zoomedRibbon2Items {
        iv {
          title
          picture {
            url
            fileSize
          }
        }
      }

      zoomedRibbon3Title { iv }
      zoomedRibbon3TextColor { iv }
      zoomedRibbon3Color { iv }
      zoomedRibbon3Items {
        iv {
          title
          picture {
            url
            fileSize
          }
        }
      }

      collectionTitle { iv }
      collectionTextColor { iv }
      collectionColor { iv }
      collection {
        iv {
          title
          titleColor
          legend
          legendColor
          description
          descriptionColor
          thumb {
            url
            fileSize
          }
          images {
            url
            fileSize
          }
        }
      }

      collection2Title { iv }
      collection2TextColor { iv }
      collection2Color { iv }
      collection2 {
        iv {
          title
          titleColor
          legend
          legendColor
          description
          descriptionColor
          thumb {
            url
            fileSize
          }
          images {
            url
            fileSize
          }
        }
      }

      collection3Title { iv }
      collection3TextColor { iv }
      collection3Color { iv }
      collection3 {
        iv {
          title
          titleColor
          legend
          legendColor
          description
          descriptionColor
          thumb {
            url
            fileSize
          }
          images {
            url
            fileSize
          }
        }
      }

      logoLink { iv }
      logoPicture {
        iv {
          url
          fileSize
        }
      }

      logos {
        iv {
          picture {
              url
              fileSize
          }
          text
          pictureLink
        }
      }

      mentionLabel { iv }
    }
  }
}
`,
]);
